<template>
  <v-container fluid grid-list-lg px-0>
    <v-layout>
      <v-flex xs9 >
        <template v-if="fetchingData">
          <div class="text-xs-center mt-4">
            <v-progress-circular :size="80" color="primary" indeterminate />
          </div>
        </template>
        <template v-else>
          <department-summary-report-table v-model="selectedIndicators" :period="period" />
        </template>
      </v-flex>
      <v-flex xs3>
        <v-select
            v-model="selectedInstitute"
            label="Выберите институт"
            :items="institutions"
            :item-text="`title.${locale}`"
            item-value="code"
            no-data-text="Список пуст"
            :disabled="disabledFilter"
        />
        <v-select
            v-model="selectedDepartment"
            label="Выберите кафедру"
            :items="departments"
            :item-text="`title.${locale}`"
            item-value="code"
            no-data-text="Список пуст"
            :clearable="isUserSuperManager"
            :disabled="disabledFilter"
        />
        <v-btn color="primary" class="right" @click="calculateSummaryReport()" :disabled="calculating || !selectedDepartment" :loading="calculating">
          Сформировать
          <template #loader>
            <span class="loader">
              <v-icon light>cached</v-icon>
            </span>
          </template>
        </v-btn>

        <hr>

        <v-btn color="secondary" class="right" @click="calculateSummaryReportOrleu()" :disabled="calculatingOrleu || !selectedDepartment" :loading="calculatingOrleu">
          Орлеу
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DepartmentSummaryReportTable from "@/components/reports/summary/DepartmentTable";
import apiIndicators from "@/api/indicators";
export default {
  components: {
    DepartmentSummaryReportTable,
  },
  data: () => ({
    fetchingData: false,
    calculating: false,
    calculatingOrleu: false,

    disabledFilter: false,

    selectedInstitute: null,
    selectedDepartment: null,

    selectedIndicators: [],
  }),
  computed: {
    locale () {
      return this.$i18n.locale
    },
    period () {
      return this.$route.params.period
    },
    isUserHead () {
      return this.$store.getters.isUserHead
    },
    userDepartment () {
      return this.$store.getters.userDepartment
    },
    isUserSuperManager () {
      return this.$store.getters.isUserSuperManager
    },
    institutions () {
      return Object.values(this.$store.getters['institutions/getInstitutions'])
          .sort((a, b) => a.title[this.locale].localeCompare(b.title[this.locale]))
    },
    departments () {
      return Object.values(this.$store.getters['departments/getDepartments'])
          .filter(department => department.institution.code === this.selectedInstitute)
          .sort((a, b) => a.title[this.locale].localeCompare(b.title[this.locale]))
    }
  },
  watch: {
    period () {
      this.init()
    },
    selectedInstitute () {
      if (!this.isUserHead) {
        this.selectedDepartment = null
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init () {
      this.fetchingData = true
      await this.loadInstitutions()
      await this.loadDepartments()

      if (this.institutions.length > 0) {
        this.selectedInstitute = this.institutions[0].code
      }

      if (this.isUserHead) {
        const department = this.$store.getters['departments/getDepartments'][this.userDepartment]
        this.selectedInstitute = department.institution.code
        this.selectedDepartment = this.userDepartment

        this.disabledFilter = true
      }

      this.fetchingData = false
    },
    async loadInstitutions () {
      try {
        await this.$store.dispatch('institutions/loadInstitutions')
      } catch (e) {
        this.$events.$emit('notify', {
          message: e.message,
          type: 'error'
        })
      }
    },
    async loadDepartments () {
      try {
        await this.$store.dispatch('departments/loadDepartments')
      } catch (e) {
        this.$events.$emit('notify', {
          message: e.message,
          type: 'error'
        })
      }
    },

    async calculateSummaryReportOrleu () {
      this.calculatingOrleu = true
      try {
        const selectedIndicators = [
          {
            sequence: '99',
            title: 'Профессиональная переподготовка, повышение квалификации или стажировка по специальности в организациях образования, научно-исследовательских организациях, организациях дополнительного образования, на предприятиях.',
            hasChildren: true,
          },
          {
            sequence: '99.1',
            parent: '99',
            title: 'республиканских (в том числе с приглашением лектора из республиканской организации, дистанционные)',
            unit: '1 преподаватель',
            award: 0,
            indicators: ['4a3fd95c-2021-2022-a3ec-32ca399264bb']
          },
        ];

        console.log(selectedIndicators);

        const response = await apiIndicators.calculateSummaryReportDepartment(this.period, selectedIndicators, this.selectedInstitute, this.selectedDepartment)
        const headers = this.$store.getters.getResponseHeaders
        const header = headers['content-disposition']
        if (!header) {
          let result = await response.text();
          result = JSON.parse(result)
          throw new Error(result.message || 'Возникла ошибка')
        }
        const filename = header.substring(header.indexOf('"') + 1, header.lastIndexOf('"'))
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url;
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (e) {
        this.$events.$emit('notify', {
          message: e.message,
          type: 'error'
        })
      }
      this.calculatingOrleu = false
    },
    async calculateSummaryReport () {
      this.calculating = true
      try {
        const selectedIndicators = this.selectedIndicators
        const response = await apiIndicators.calculateSummaryReportDepartment(this.period, selectedIndicators, this.selectedInstitute, this.selectedDepartment)
        const headers = this.$store.getters.getResponseHeaders
        const header = headers['content-disposition']
        if (!header) {
          let result = await response.text();
          result = JSON.parse(result)
          throw new Error(result.message || 'Возникла ошибка')
        }
        const filename = header.substring(header.indexOf('"') + 1, header.lastIndexOf('"'))
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url;
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (e) {
        this.$events.$emit('notify', {
          message: e.message,
          type: 'error'
        })
      }
      this.calculating = false
    }
  },
}
</script>

<style scoped>
.loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
